var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "records-shortcut-cell-wrapper",
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c("div", { staticClass: "top-section" }, [
        _c("div", { staticStyle: { "margin-right": "8px" } }, [
          _c("img", {
            staticStyle: { height: "40px", width: "40px" },
            attrs: { src: _vm.getIconURL }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "title-styling" }, [_vm._v(_vm._s(_vm.title))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "date-cell" }, [
        _c("strong", [_vm._v(_vm._s(_vm.date.datePrefix))]),
        _vm._v(" " + _vm._s(_vm.date.date))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }